import React from 'react';
import { USE_TRIP_URL } from '../../constants/ROUTER_PATH_TITLE';

const UseTripUrlPage = () => {
  document.title = USE_TRIP_URL.TITLE;

  return (
    <>
      <div className="full-center" style={{ maxWidth: '100%', textAlign: 'center' }}>
        <h3>To access your trip, please use the URL you&apos;ve received by email.</h3>
      </div>
    </>
  );
};

export default UseTripUrlPage;
